import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CallToAction = () => {
  return (
    <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 lg:p-12 text-center shadow-2xl relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-accent/10 opacity-50"></div>
      <div className="relative z-10 max-w-3xl mx-auto">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-6">
          <Icon name="MessageCircle" size={24} className="text-accent" />
        </div>
        
        <h2 className="font-heading font-bold text-3xl lg:text-4xl text-text-primary mb-4">
          "Looking for a Research-Driven Developer?"
        </h2>
        
        <p className="text-text-secondary text-lg lg:text-xl leading-relaxed mb-8 max-w-2xl mx-auto">
          "Let’s create impactful solutions together — from space to code."
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link 
            to="/contact" 
            className="w-full sm:w-auto"
            title="Navigate to the Contact & Availability profile"
            aria-label="Propose a Collaboration or Project Discussion"
          >
            <Button
              variant="primary"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              className="w-full"
            >
              Get In Touch
            </Button>
          </Link>
          
          <Link 
            to="/resume" 
            className="w-full sm:w-auto"
            title="Navigate to the Interactive Resume Dashboard"
            aria-label="View and Download Sudhan's complete professional credentials"
          >
            <Button
              variant="outline"
              size="lg"
              iconName="Download"
              iconPosition="right"
              className="w-full"
            >
              Download Resume
            </Button>
          </Link>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 text-text-muted">
            <div className="flex items-center space-x-2">
              <Icon name="BookOpen" size={16} />
              <span className="text-sm">Research-Based Development</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Rocket" size={16} />
              <span className="text-sm">ISRO/NASA Experience</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Users" size={16} />
              <span className="text-sm">STEM Outreach & Team Player</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;